import React, { useState, useEffect } from 'react';
import './HomePage.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';


const HomePage = () => {

  const { t } = useTranslation();
  const [currentProfileIndex, setCurrentProfileIndex] = useState(0);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [onlineCount, setOnlineCount] = useState(getRandomOnlineCount());
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  function getRandomOnlineCount() {
    return Math.floor(Math.random() * (4500 - 1000 + 1)) + 1000;
  }

  useEffect(() => {
    const profileInterval = setInterval(() => {
      setCurrentProfileIndex((prevIndex) =>
        prevIndex === profiles.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    const onlineCountInterval = setInterval(() => {
      setOnlineCount(getRandomOnlineCount());
    }, 10000);

    return () => {
      clearInterval(profileInterval);
      clearInterval(onlineCountInterval);
    };
  // Ne doit s'exécuter qu'au montage, profiles est une constante locale
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleQuestion = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const profiles = [
    {
      id: 1,
      name: "Jenny B.",
      age: 23,
      image: "/assets/images/user/pic1.png",
      type: "invite.types.maquis"
    },
    {
      id: 2,
      name: "Sarah M.",
      age: 21,
      image: "/assets/images/user/pic1.jpeg",
      type: "invite.types.lounge"
    },
    {
      id: 3,
      name: "Emma L.",
      age: 24,
      image: "/assets/images/user/pic3.jpeg",
      type: "notifications.invitations.standard"
    },
    {
      id: 4,
      name: "Nadia K.",
      age: 26,
      image: "/assets/images/user/pic4.jpeg",
      type: "invite.types.cinema"
    }
  ];

  const profilesFake2 = [
    {
      id: 1,
      name: "Amanda",
      age: 23,
      image: "/assets/images/user/pic1.jpg",
      type: "invite.types.maquis"
    },
    {
      id: 2,
      name: "Joyce",
      age: 20,
      image: "/assets/images/user/pic2.jpg",
      type: "invite.types.lounge"
    },
    {
      id: 3,
      name: "Karelle",
      age: 24,
      image: "/assets/images/user/pic5.jpeg",
      type: "notifications.invitations.standard"
    },
    {
      id: 4,
      name: "Aïcha ",
      age: 21,
      image: "/assets/images/user/pic2.jpeg",
      type: "invite.types.cinema"
    }
  ];

  return (
    <div className="mainHome">
      <svg width="0" height="0">
        <defs>
          <linearGradient id="icon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF6B8B" />
            <stop offset="100%" stopColor="#FF8E53" />
          </linearGradient>
        </defs>
      </svg>
      <div className="homepage">
        {/* Bouton fixe en bas */}
        <div className="fixed-bottom-cta">
          <button onClick={() => navigate('/signup')} className="join-now">REJOINDRE MAINTENANT →</button>
        </div>

        <nav className={`top-nav ${isScrolled ? 'scrolled' : ''}`}>
          <div className="logo">
         <img 
            src={process.env.PUBLIC_URL + '/assets/img/fulllogo_transparent_nobuffer.png'} 
            alt="Trakna Logo" 
            className="home-logo"
          />
          </div>
          
          {/* Menu burger pour mobile */}
          <button className="mobile-menu-button" onClick={toggleMobileMenu}>
            <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              {!isMobileMenuOpen ? (
                <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              ) : (
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              )}
            </svg>
          </button>

          {/* Menu mobile */}
          <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
            <div className="mobile-menu-content">
              <a href="#about" className="mobile-menu-item" onClick={() => setIsMobileMenuOpen(false)}>À propos</a>
              <a href="#testimonials" className="mobile-menu-item" onClick={() => setIsMobileMenuOpen(false)}>Avis</a>
              <a href="#faq" className="mobile-menu-item" onClick={() => setIsMobileMenuOpen(false)}>FAQ</a>
              <button onClick={() => navigate('/login')} className="mobile-menu-item connect">Se connecter</button>
              <button onClick={() => navigate('/signup')} className="mobile-menu-item join-now">REJOINDRE MAINTENANT →</button>
            </div>
          </div>

          {/* Navigation desktop */}
          <div className="nav-links desktop-only">
            <a href="#about" className="nav-link">À propos</a>
            <a href="#testimonials" className="nav-link">Avis</a>
            <a href="#faq" className="nav-link">FAQ</a>
          </div>

          <div className="nav-right desktop-only">
            <div className="online-count">
              <span key={onlineCount}>{onlineCount.toLocaleString()}</span> membres en ligne
            </div>
            <button onClick={() => navigate('/login')} className="connect-btn">Se connecter</button>
            <button onClick={() => navigate('/signup')} className="join-btn join-now">Rejoindre maintenant →</button>
          </div>
        </nav>

        <div className="hero-section">
          <div className="phone-preview">
            <div className="phone-container">
              <img 
                src="https://cdn.prod.website-files.com/66e0939a348d31d4a2ff0a2a/66e1c12bc3ba4d9ba634d734_iphone%20(1).avif"
                alt="iPhone frame"
                className="phone-frame-image"
              />
              <div className="phone-content">
                <div className="profile-slider">
                  <div 
                    className="profile-slider-track" 
                    style={{ 
                      transform: `translateX(-${currentProfileIndex * 100}%)`,
                      transition: 'transform 0.5s ease-in-out'
                    }}
                  >
                    {profiles.map((profile) => (
                      <div className="profile-card" key={profile.id}>
                        <div className="dz-media-card style-4 notification-card">
                          <div className="dz-media aspect-ratio-box">
                            <img 
                              src={profile.image} 
                              className="aspect-ratio-image"
                              alt={profile.name}
                            />
                          </div> 
                          <div className="dz-content">
                            <div className="left-content" style={{ cursor: 'pointer' }}>
                              <h6 className="title">
                                {profile.name}, {profile.age}
                              </h6>
                            </div>
                            <div className="invitation-actions">
                              <button 
                                className="invitation-button decline-button"
                                disabled={true}
                              >
                                {t('notifications.actions.decline')}
                              </button>
                              <button 
                                className="invitation-button accept-button"
                                disabled={true}
                              >
                                {t('notifications.actions.accept')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-content">
            <div className="welcome-badge">
              <span className="lock-icon">🔒</span>
              <span>BIENVENUE SUR TRAKNA</span>
            </div>
            
            <h1 className="hero-title">
              Fais des rencontres<br />sans prise de tête<br />et sans tabous 🔥
            </h1>

            <div className="hero-features">
              <div className="feature">Photos hot autorisées 🔞</div>
              <div className="feature">+10 000 membres actifs</div>
              <div className="feature">75% de filles sur le site</div>
            </div>

            <div className="rating-section">
              <div className="rating">
                <span className="rating-score">4.9</span>
                <div className="rating-stars">
                  <div className="stars-outer">
                    <div className="stars-inner" style={{ width: '90%' }}>★★★★★</div>
                    ★★★★★
                  </div>
                </div>
                <span className="rating-count">• Le meilleur site de rencontres</span>
              </div>
            </div>

            <button onClick={() => navigate('/signup')} className="cta-button join-now">REJOINS L'AVENTURE →</button>
          </div>
        </div>

        <div id="about" className="second-section">
          <div className="content-left">
            <h2>Invite direct et fais kiffer ! 🎯</h2>
            <p>Restaurant, Lounge-Bar, Maquis, Plage, Cinéma ou Gaming... Invite où tu veux, quand tu veux ! Pas besoin de matcher pour faire le premier pas. 😎</p>
            <div className="features-icons">
              <span className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm3-8h-2V7h-2v4H9v2h2v4h2v-4h2v-2z" className="icon-path"/>
                </svg>
                Profils vérifiés ✓
              </span>
              <span className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" className="icon-path"/>
                </svg>
                Paiement ultra discret
              </span>
              <span className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" className="icon-path"/>
                </svg>
                100% confidentiel
              </span>
              <span className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm3-8h-2V7h-2v4H9v2h2v4h2v-4h2v-2z" className="icon-path"/>
                </svg>
                Photos hot acceptées
              </span>
            </div>
            <button onClick={() => navigate('/signup')} className="cta-button join-now">REJOINS-NOUS →</button>
          </div>
          <div className="content-right">
            <div className="profile-grid">
              {profilesFake2.map((profile) => (
                <div className="profile-card" key={profile.id}>
                  <div className="dz-media-card style-4 notification-card">
                    <div className="dz-media aspect-ratio-box">
                      <img 
                        src={profile.image} 
                        className="aspect-ratio-image"
                        alt={profile.name}
                      />
                    </div> 
                    <span className="invitation-type">{t(profile.type)}</span>
                    <div className="dz-content">
                      <div className="left-content" style={{ cursor: 'pointer' }}>
                        <h6 className="title">
                          {profile.name}, {profile.age}
                        </h6>
                      </div>
                      <div className="invitation-actions">
                        <button 
                          className="invitation-button decline-button"
                          disabled={true}
                        >
                          {t('notifications.actions.decline')}
                        </button>
                        <button 
                          className="invitation-button accept-button"
                          disabled={true}
                        >
                          {t('notifications.actions.accept')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div id="testimonials" className="testimonials-section">
          <h2>La communauté en parle... 🔥</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="testimonial-text">"Enfin un site où on peut être direct ! J'ai rencontré des gens super cools et les sorties sont toujours au top. Le maquis de la dernière fois était 🔥"</p>
              <div className="testimonial-author">
                <img src="/assets/images/user/pic1.jpg" alt="Amanda" className="author-pic" />
                <div className="author-info">
                  <span className="author-name">Amanda</span>
                  <span className="author-status">Membre VIP</span>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <p className="testimonial-text">"Le meilleur site pour faire des rencontres sans prise de tête ! Les gens sont vrais et on peut parler de tout. Les photos hot sont un vrai plus 😏"</p>
              <div className="testimonial-author">
                <img src="/assets/images/user/pic2.jpg" alt="Joyce" className="author-pic" />
                <div className="author-info">
                  <span className="author-name">Joyce</span>
                  <span className="author-status">Membre</span>
                </div>
              </div>
            </div>
          </div>

          <div id="faq" className="faq-section">
            <h2>Questions fréquentes 🤔</h2>
            <div className="faq-list">
              <div className="faq-item">
                <button 
                  className={`faq-button ${activeQuestion === 0 ? 'active' : ''}`}
                  onClick={() => toggleQuestion(0)}
                >
                  C'est quoi Trakna ?
                  <span className="plus-icon">{activeQuestion === 0 ? '−' : '+'}</span>
                </button>
                <div className={`faq-answer ${activeQuestion === 0 ? 'active' : ''}`}>
                  Trakna est la première plateforme de rencontres qui te permet d'inviter directement les gens à sortir ! 
                  Resto, maquis, plage... Pas besoin de matcher pendant des jours, ici tu peux faire le premier pas direct. 
                  En plus, on accepte les photos hot et on garantit ta confidentialité à 100% ! 🔥
                </div>
              </div>

              <div className="faq-item">
                <button 
                  className={`faq-button ${activeQuestion === 1 ? 'active' : ''}`}
                  onClick={() => toggleQuestion(1)}
                >
                  Est-ce qu'il y a des comptes fake ?
                  <span className="plus-icon">{activeQuestion === 1 ? '−' : '+'}</span>
                </button>
                <div className={`faq-answer ${activeQuestion === 1 ? 'active' : ''}`}>
                  Non ! On vérifie chaque profil manuellement avant validation. 
                  Tous nos membres doivent confirmer leur identité, comme ça tu es sûr(e) de parler à de vraies personnes. 
                  La confiance c'est la base chez nous ! 💪
                </div>
              </div>

              <div className="faq-item">
                <button 
                  className={`faq-button ${activeQuestion === 2 ? 'active' : ''}`}
                  onClick={() => toggleQuestion(2)}
                >
                  Est-ce qu'il y a beaucoup de profils de filles ?
                  <span className="plus-icon">{activeQuestion === 2 ? '−' : '+'}</span>
                </button>
                <div className={`faq-answer ${activeQuestion === 2 ? 'active' : ''}`}>
                  Oui ! Plus de 75% de nos membres sont des filles. 
                  On a mis en place plein de mesures pour que les filles se sentent en sécurité sur Trakna, 
                  c'est pour ça qu'elles adorent notre plateforme ! 👯‍♀️
                </div>
              </div>

              <div className="faq-item">
                <button 
                  className={`faq-button ${activeQuestion === 3 ? 'active' : ''}`}
                  onClick={() => toggleQuestion(3)}
                >
                  Est-ce que mes photos hot sont protégées ?
                  <span className="plus-icon">{activeQuestion === 3 ? '−' : '+'}</span>
                </button>
                <div className={`faq-answer ${activeQuestion === 3 ? 'active' : ''}`}>
                  À 100% ! Tes photos sont cryptées et accessibles uniquement aux personnes que tu choisis.
                  Tu peux aussi les retirer quand tu veux. Ta vie privée est notre priorité ! 🔒
                </div>
              </div>

              <div className="faq-item">
                <button 
                  className={`faq-button ${activeQuestion === 4 ? 'active' : ''}`}
                  onClick={() => toggleQuestion(4)}
                >
                  Comment ça marche les invitations ?
                  <span className="plus-icon">{activeQuestion === 4 ? '−' : '+'}</span>
                </button>
                <div className={`faq-answer ${activeQuestion === 4 ? 'active' : ''}`}>
                  Super simple ! Tu vois un profil qui te plaît ? Tu cliques sur "Inviter" et tu choisis le lieu : 
                  resto, maquis, plage, cinéma ou gaming... Pas besoin de matcher avant, 
                  tu peux inviter qui tu veux, quand tu veux ! 🎯
                </div>
              </div>
              
            </div>
            <button onClick={() => navigate('/signup')} className="cta-button join-now">REJOINDRE MAINTENANT →</button>
          </div>
        </div>

        <div className="app-footer">
          <div className="footer-content">


            <div className="footer-bottom">
              <div className="footer-contact">
              <div className="footer-logo">
                <span className="logo-text">Trakna</span>
                <p className="footer-slogan">@2024 Trakna</p>
              </div>
            
              </div>
              <div className="footer-nav">
                <div className="footer-section">
                  <h4>Navigation</h4>
                  <ul>
                    <li><a href="#about">À propos</a></li>
                    <li><a href="#testimonials">Avis</a></li>
                    <li><a href="#faq">FAQ</a></li>
                  </ul>
                </div>
                <div className="footer-section">
                  <h4>Légal</h4>
                  <ul>
                    <li><a href="/terms"> {t('welcome.legal.terms')}</a></li>
                    <li><a href="/privacy">  {t('welcome.legal.privacy')}</a></li>
                  </ul>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
